import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { ICustomerTemplate } from "@/interfaces/customer-template.interface";
import messageTemplateService from "@/services/message-template.service";
import { RequestsBaseReturn } from "@/types/requests.types";

export type UseGetMessageTemplateByIdReturn = RequestsBaseReturn<ICustomerTemplate | null>;

const useGetMessageTemplateById = (id?: number): UseGetMessageTemplateByIdReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<ICustomerTemplate, Error>(
    id ? `${SWR_KEYS.getMessageTemplateById}-${id}` : null,
    () => messageTemplateService.getById(Number(id)),
    { revalidateOnFocus: false }
  );

  return { data, isLoading, error };
};

export default useGetMessageTemplateById;
